module.exports = __webpack_public_path__ + "img/qr_code.21e7a639.svg";